import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import About from './About';
import ContinueWith from './ContinueWith';
import ActivateQRCode from './ActivateQRCode';
// import ContinueWithDownload from './ContinueWithDownload';
import EnterEmail from './EnterEmail';
import EmailConfirmation from './EmailConfirmation';
import CreateEmailSent from './CreateEmailSent';
import CustomizeExperience from './CustomizeExperience';
import ResetEmailSent from './ResetEmailSent';
import VideoSelection from './VideoSelection';
import Congratulations from './Congratulations';
import CreateQRCodes from './CreateQRCodes';
import View from './View';
import Share from './Share';
// import facebookAuth from './FacebookAuth';
import Privacy from './Privacy';
import Farewell from './Farewell';
import Terms from './Terms';
import MyCodes from './MyCodes';
import Home from './Home';
import CertTest from './CertTest'

// import axios from 'axios';

import QRQinectAPI from '../QRQinectAPI';
import { FACEBOOK_APP_ID } from '../QRQinectConstants';
// import DownloadVideo from './DownloadVideo';
import VideoDownloadSent from './VideoDownloadSent';
import FacebookAuth from './FacebookAuth';
import AccountPassword from './AccountPassword';

const reservedWords = [
    'terms',
    'privacy',
    'conditions',
    'facebookAuth',
    'report',
    'cassiescookies',
    'activateQRCode',
    'index.html',
    'accountPassword',
    'login',
    'createCodes',
    'passwordResetSent',
    'farewell',
    'passwordCreateSent',
    'certTest'];

class Index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            redirect: false
        }
        this.updateState = this.updateState.bind(this);
    }
    updateState(newState) {
        this.setState(newState);
    }
    /**
     * get the qrCodeId that was provided
     * get the campaign information for that code
     * determine which type of page will be displayed (buyer, receiver, or share)
     * redirect to the appropriate page if needed
     */
    componentDidMount() {
        let viewType = "Buyer";
        let redirectTo;
        // get the qr id from the url
        let qrCodeGUID = matchPath(window.location.pathname, {
            path: '/:id',
            exact: true
        });
        qrCodeGUID = qrCodeGUID ? qrCodeGUID.params.id : null;
        if (qrCodeGUID) {

            // lets see if this is a special url and not a qrCodeGUID
            if (reservedWords.indexOf(qrCodeGUID) >= 0) {
                this.setState({ loaded: true });
                return;
            }
            // log the scan
            QRQinectAPI.logScan(qrCodeGUID);
            // axios.get(API_URL + 'api/v1/logScan', {
            //     params: {
            //         QRCode: qrCodeGUID
            //     }
            // });
            // redirect this /:id to scan/:id/(account | view)
            this.setState({ redirect: true });
        }
        // TODO: we need to know if we are heading to /scan/:id/view
        // redirect if we are
        let scannedViewQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id/view',
            exact: true
        });
        let scannedQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id',
            exact: false
        });
        let sharedQRCode = matchPath(window.location.pathname, {
            path: '/share/:id',
            exact: false
        });
        let scanId = scannedQRCode ? scannedQRCode.params.id : null;
        let shareId = sharedQRCode ? sharedQRCode.params.id : null;
        qrCodeGUID = qrCodeGUID || scanId || shareId;

        // get the logo, style, etc. from the api
        if (qrCodeGUID) {
            this.setState({ qrCodeGUID: qrCodeGUID });
            QRQinectAPI.getCampaignValues(qrCodeGUID)
            // axios.get(API_URL + 'api/v1/getCampaignValues', {
            //     params: {
            //         QRCode: qrCodeGUID
            //     }
            // })
                .then((response) => {
                    this.setState(response.data);
                    this.setState({customizableQR: response.data.CustomizableWebExperience});
                    // are we showing the buyer, receiver, or share screen?
                    if (sharedQRCode && shareId) {
                        viewType = 'Share';
                    } else if (response.data.Video.ID) {
                        if (this.state.redirect) {
                            viewType = 'Receiver';
                        }
                        redirectTo = '/scan/' + qrCodeGUID + '/view';
                    } else if (response.data.DemoQRCode === true && response.data.Token !== "") {
                        redirectTo = '/scan/' + qrCodeGUID + '/video/' + response.data.Token;
                        this.setState({redirect: true, demoQR: true});
                    } else {
                        viewType = 'Buyer';
                        redirectTo = '/scan/' + qrCodeGUID + '/account';
                    }
                    // check for a redirect only qr
                    if (response.data.QRCode.Redirect && (!scanId || scannedViewQRCode)) {
                        window.location.href = response.data.QRCode.Redirect;
                        return;
                        // this.setState({redirect: true});
                    }

                    this.setState({ Screen: viewType });
                    this.setState({ loaded: true });
                    this.setState({ redirectTo: redirectTo });

                    // is this even a valid QRCode?
                    if (response.data.QRCode.ID === 0) {
                        this.setState({ loaded: false, error: true, errorMessage: "Invalid QRCode, please try again", redirect: false });
                        console.log("invalid qr code");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                    this.setState({ loaded: false, error: true, errorMessage: "Invalid QRCode, please try again", redirect: false });
                });
        } else {
            this.setState({ loaded: true });
            // this must be just a call to '/', we should do something show something other than 'Loading...'
        }
    }
    /**
     * Creates the CSS for the given page (either buyer, receiver, or share)
     */
    renderCSS() {
        if (!this.state.Screen) {
            return;
        }
        let obj;
        // switch (this.state.Screen) {
        //     case 'Buyer':
        //         obj = this.state.BuyerScreenSettings;
        //         break;
        //     case 'Receiver':
        //         obj = this.state.ReceiverScreenSettings;
        //         break;
        //     case 'Share':
        //         obj = this.state.ShareScreenSettings;
        //         break;
        // }
        obj = this.state.BuyerScreenSettings;
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
        body {
          color: ${obj.TextColor};
          font-family: '${obj.Font}';
        }
        body:before {
          background-image: url(${obj.BackgroundPath});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: ${obj.BackgroundColor};
        }
        .button {
          color: ${obj.ButtonTextColor};
          background: ${obj.ButtonColor};
        }
        .primaryTextColor {
          color: ${obj.TextColor};
        }
        .buttonBackgroundColor {
          background: ${obj.ButtonColor};
        }
        .logoImage {
          content: url(${obj.LogoPath});
          width: 50%;
          margin: 0 auto;
        }
        .CircularProgressbar-path {
          stroke: ${obj.ButtonColor};
          fill: ${obj.ButtonColor};
        }
        .CircularProgressbar-text {
          stroke: transparent;
          fill: ${obj.TextColor};
        }
        .slick-dots li.slick-active button {
          background: ${obj.ButtonColor};
        }
        .navbar {
          color: ${obj.ButtonTextColor};
          background: ${obj.ButtonColor};
        }
        .site-title h1 {
          color: ${obj.ButtonTextColor};
        }
        .secondaryColor {
          color: ${obj.ButtonColor};
        }
        .container .top {
          background-image: url(${obj.BackgroundPath});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }        
      `}} />
        );
    }
    renderRedirect() {
        if (this.state.redirect) {
            if (this.state.redirectTo) {
                return (
                    <Redirect to={`${this.state.redirectTo}`} />
                );
            }
        }
    }
    render() {
        if (this.state.loaded) {
            return (
                <Router>
                    <div>
                        {this.renderCSS()}
                        {this.renderRedirect()}

                        {/* Default Screen Route (shouldn't really be hit) */}
                        {/* TODO: create qr code scanner on this page https://www.sitepoint.com/create-qr-code-reader-mobile-website/ */}
                        {/* <Route path="/" exact component={Home} /> */}
                        <Route path="/" exact render={(props) => { return (<Home updateState={this.updateState}></Home>); }} />
                        {/* <Route path="/login" exact component={Login} /> */}
                        <Route path="/login" exact render={(props) => { return (<ContinueWith userType="Buyer" redirect="/report/" updateState={this.updateState}></ContinueWith>); }} />
                        <Route path="/index.html" exact component={Home} />
                        <Route path="/terms" exact component={Terms} />
                        <Route path="/conditions" exact component={Terms} />
                        <Route path="/privacy" exact component={Privacy} />
                        <Route path="/farewell" exact component={Farewell} />
                        <Route path="/certTest" exact component={CertTest} />
                        <Route path="/accountPassword/create/:token" render={(props) => { return (<AccountPassword actionType="create" token={props.match.params.token}></AccountPassword>); }} />
                        <Route path="/accountPassword/update/:token" render={(props) => { return (<AccountPassword actionType="update" token={props.match.params.token}></AccountPassword>); }} />
                        <Route path="/report/:token" render={(props) => { return (<MyCodes token={props.match.params.token}></MyCodes>); }} />

                        <Route path="/createCodes/:token" render={(props) => { return (<CreateQRCodes token={props.match.params.token}></CreateQRCodes>); }} />

                        {/* Special route for cassie's cookies to enter their users */}
                        <Route path="/cassiescookies" render={(props) => { return (<ContinueWith userType="Cassie" QRCode={this.state.QRCode} updateState={this.updateState}></ContinueWith>); }} />

                        {/* Special route to activate inactive QRCodes and provide them with a nickname */}
                        <Route path="/activateQRCode" render={(props) => { return (<ActivateQRCode></ActivateQRCode>); }} />

                        <Route path="/facebookAuth" render={(props) => {
                            return (<FacebookAuth
                                appId={FACEBOOK_APP_ID}
                                fields="name,email,picture"
                                state="fbredirected"
                            />);
                        }} />

                        {/* Share Screen Route */}
                        <Route path="/share/:id" exact render={(props) => { return (<Share BodyHTML={this.state.ShareScreenBodyHTML.HTML} QRCode={this.state.QRCode} Video={this.state.Video} objectSettings={this.state.ShareScreenSettings}></Share>); }} />

                        {/* Buyer Screen Routes */}
                        <Route path="/scan/:id/welcome" component={About} />

                        <Route path="/scan/:id/customizeExperience/:token" render={(props) => { return (<CustomizeExperience qrGUID={props.match.params.id} token={props.match.params.token} demoQR={this.state.demoQR} state={{ Buyer: this.state.Buyer, QRCode: this.state.QRCode }} updateState={this.updateState} backgroundColor={this.state.BuyerScreenSettings.BackgroundColor} buttonColor={this.state.BuyerScreenSettings.ButtonColor} buttonTextColor={this.state.BuyerScreenSettings.ButtonTextColor}></CustomizeExperience>); }} />

                        {/* <Route path="/scan/:id/account" component={ContinueWith} /> */}
                        <Route path="/scan/:id/account" render={(props) => { return (<ContinueWith userType="Buyer" Video={this.state.DefaultVideo} QRCode={this.state.QRCode} updateState={this.updateState}></ContinueWith>); }} />
                        {/* <Route path="/scan/:id/email" component={EnterEmail} /> */}
                        <Route path="/scan/:id/email" render={(props) => { return (<EnterEmail updateState={this.updateState}></EnterEmail>); }} />
                        <Route path="/scan/:id/verification" component={EmailConfirmation} />
                        <Route path="/passwordResetSent" component={ResetEmailSent} />
                        <Route path="/passwordCreateSent" component={CreateEmailSent} />
                        {/* <Route path="/scan/:id/video" component={VideoSelection} /> */}
                        <Route path="/scan/:id/video" render={(props) => { return (<VideoSelection demoQR={this.state.demoQR} state={{ Buyer: this.state.Buyer, QRCode: this.state.QRCode }} updateState={this.updateState}></VideoSelection>); }} />
                        <Route path="/scan/:id/congratulations/:token" render={(props) => { return (<Congratulations token={props.match.params.token} QRCode={this.state.QRCode.GUID} demoQR={this.state.demoQR} customizableQR={this.state.customizableQR}></Congratulations>); }} />
                        <Route path="/scan/:id/download" render={(props) => { return (<ContinueWith userType="Receiver" updateState={this.updateState} QRCode={this.state.QRCode}></ContinueWith>); }} />
                        <Route path="/scan/:id/downloadReady/:recEmail" exact component={VideoDownloadSent} />
                        <Route path="/scan/:id/downloadReady" exact component={VideoDownloadSent} />

                        {/* Receiver Screen Route */}
                        <Route path="/scan/:id/view" render={(props) => { return (<View BodyHTML={this.state.ReceiverScreenBodyHTML.HTML} QRCode={this.state.QRCode} Video={this.state.Video} objectSettings={this.state.ReceiverScreenSettings}></View>); }} />
                    </div>
                </Router>
            );
        } else {
            return (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>{this.state.error ? this.state.errorMessage : 'Loading...'}</div>
            );
        }
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Index.js